import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as RFSActionType from "../../Request-Services/constants";
import * as PunchListActionType from "../constants";
import * as WorkOrderActionType from "../../Work-Orders/constants";
import { Row, Table, Col } from "react-bootstrap";
import { CheckBoxSingle } from "../../components/checkboxes/check-box-single";
import Moment from "moment";
import SignatureCanvas from "react-signature-canvas";
import * as CommonActionType from "Common/constants";
import { Link } from "react-router-dom";
import Datetime from "react-datetime";
import { AppSettings } from "../../constants";
import { Popup } from "components/Popup/popup";
import TagsInput from "../../components/tag-input";
import Translate from "components/translate";
import { printEOF } from "../../helper/unit-helper";
import { Modal, Carousel } from "react-bootstrap";

import "../epl.css";

const popupStyle = {
  width: 370,
  height: 200,
  top: -222,
  left: 160,
};

const InspectorList = [
  { title: "GC/Contractor", color: "#ECEDEB" },
  {
    title: "Property mngr or equal",
    color: "#F4F6F7",
    fullTitle: "Property manager or equal",
  },
  { title: "Owner rep or equal", color: "#ECEDEB" },
];

const TAGS_LIST = [9, 13, 188];
const InspectorEnum = { GCContractor: 0, Property: 1, Owner: 2 };

class EPLForm extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    EPLProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      id: null,
      refNo: props.match.params.RFSID,

      error: {
        dateCreated: null,
        buildingDepartmentFinalDate: null,
      },
      unSavedChange: false,
      onSaveAndProceed: false,
      showConfirmSavePopup: false,
      showEmailInputBox: false,
      inputProps: { placeholder: "Type email address" },

      builderInfo: {},
      homeOwnerInfo: {},
      templateName: null,
      project: null,
      buildingPhase: null,
      address: null,
      buildingDepartmentFinalDate: null,

      sections: [],
      checkboxes: {},
      workOrderTitles: [],
      workOrderTitleList: [],
      inspectors: [{}, {}, {}],
      finalAccepted: {},
      recipientEmail: [],
      suggestions: [],
      showErrorModal: false,
      errorMessage: "Unable to connect to server. Please try again.",
      showAttachmentModal: false,
      currentAttachmentUrls: [],
      customSettings: {},
      customTitles: [null, null, null],
    };
  }

  componentDidMount() {
    this.getEPL();
    this.getCustomSettings();
    this.props.dispatch({
      type: WorkOrderActionType.GET_ALL_USER_EMAILS,
      params: {},
      callback: (res) => {
        this.setState({ suggestions: res });
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.EPLProfile !== this.props.EPLProfile) {
      let gcContractor = nextProps.EPLProfile.gcContractor;
      let propertyManager = nextProps.EPLProfile.propertyManager;
      let ownerRep = nextProps.EPLProfile.ownerRep;
      let finalAccepted = nextProps.EPLProfile.finalAccepted;

      gcContractor.signatureDate = gcContractor.signatureDate
        ? Moment(gcContractor.signatureDate)
        : null;
      propertyManager.signatureDate = propertyManager.signatureDate
        ? Moment(propertyManager.signatureDate)
        : null;
      ownerRep.signatureDate = ownerRep.signatureDate
        ? Moment(ownerRep.signatureDate)
        : null;
      finalAccepted.signatureDate = finalAccepted.signatureDate
        ? Moment(finalAccepted.signatureDate)
        : null;

      this.setState({
        id: nextProps.EPLProfile.id,
        builderInfo: nextProps.EPLProfile.builderInfo,
        homeOwnerInfo: nextProps.EPLProfile.homeOwnerInfo,
        templateName: nextProps.EPLProfile.templateName,
        project: nextProps.EPLProfile.project,
        buildingPhase: nextProps.EPLProfile.buildingPhase,
        address: nextProps.EPLProfile.address,
        dateCreated: nextProps.EPLProfile.dateCreated
          ? Moment(nextProps.EPLProfile.dateCreated)
          : null,
        buildingDepartmentFinalDate: nextProps.EPLProfile
          .buildingDepartmentFinalDate
          ? Moment(nextProps.EPLProfile.buildingDepartmentFinalDate)
          : null,

        sections: nextProps.EPLProfile.sections,
        workOrderTitles: nextProps.EPLProfile.workOrderTitles,
        workOrderTitleList: nextProps.EPLProfile.workOrderTitleList,
        disclaimer: nextProps.EPLProfile.disclaimer,
        recipientEmail: [],
        customTitles: [
          nextProps.EPLProfile.title1 || null,
          nextProps.EPLProfile.title2 || null,
          nextProps.EPLProfile.title3 || null,
        ],

        finalAccepted: nextProps.EPLProfile.finalAccepted,
        inspectors: [
          nextProps.EPLProfile.gcContractor,
          nextProps.EPLProfile.propertyManager,
          nextProps.EPLProfile.ownerRep,
        ],
      });

      if (nextProps.EPLProfile && nextProps.EPLProfile.sections) {
        let { checkboxes } = this.state;

        nextProps.EPLProfile.sections.map((sec) => {
          sec.items.map((item) => {
            checkboxes[item.id] = [
              item.isCheckedGcContractor,
              item.isCheckedPropertyManager,
              item.isCheckedOwnerRep,
            ];
          });
        });

        this.setState({ checkboxes: checkboxes });
      }
    }
  }

  toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();

    xhr.onload = () => {
      var reader = new FileReader();

      reader.onloadend = () => {
        callback(reader.result);
      };

      reader.readAsDataURL(xhr.response);
    };

    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  onChecked = (checkedIndex, value, data) => {
    let { checkboxes } = this.state;

    checkboxes[value][checkedIndex] = data.checked;

    this.setState({
      checkboxes: checkboxes,
      unSavedChange: true,
    });
  };

  isAllCheckedInSection = (section, checkedIndex) => {
    let { checkboxes } = this.state;
    if (!section || !section.items || section.items.length === 0) return false;

    return section.items.every(
      (item) => checkboxes[item.id] && checkboxes[item.id][checkedIndex],
    );
  };

  onSelectAllInSection = (section, checkedIndex, checked) => {
    let { checkboxes } = this.state;
    if (!section || !section.items) return;

    section.items.forEach((item) => {
      if (checkboxes[item.id]) {
        checkboxes[item.id][checkedIndex] = checked;
      }
    });

    this.setState({
      checkboxes: checkboxes,
      unSavedChange: true,
    });
  };

  getEPL = () => {
    this.props.dispatch({
      type: RFSActionType.GET_EPL_DETAIL_ASYNC,
      params: {
        refNo: this.state.refNo,
      },
    });

    this.setState({ unSavedChange: false });
  };

  getCustomSettings = () => {
    this.props.dispatch({
      type: PunchListActionType.GET_EPL_CUSTOM_TERMS,
      callback: (data) => {
        if (data) {
          this.setState({ customSettings: data });
        }
      },
    });
  };

  sendEPLEmail = () => {
    const includeWoList = (this.state.workOrderTitleList || [])
      .filter((item) => item.checked)
      .map((item) => item.refNo);
    const eplUrl = `${AppSettings.CURRENT_SITE_URI}/punch-lists/electronic-punch-list/${this.state.refNo}`;

    this.props.dispatch({
      type: RFSActionType.SEND_EPL_TEMPLATE_EMAIL_ASYNC,
      params: {
        RefNo: Number(this.state.refNo),
        Emails: this.state.recipientEmail,
        RfsUrl: eplUrl,
        TimeZoneOffset: -new Date().getTimezoneOffset(),
        IncludeWoList: includeWoList,
      },
      callback: (isSuccess) => {
        if (isSuccess) {
          this.getEPL();
        } else {
          this.setState({ showErrorModal: true });
        }
      },
    });
  };

  onClickOnEmailButton = () => {
    this.setState({ showEmailInputBox: true });
  };

  onCloseEmailBox = () => {
    this.setState({ showEmailInputBox: false });
  };

  onClickSendInEmailBox = () => {
    if (this.state.unSavedChange) {
      this.setState({
        showConfirmSavePopup: true,
        showEmailInputBox: false,
      });
    } else {
      this.setState({ showEmailInputBox: false }, this.sendEPLEmail);
    }
  };

  onClickSaveAndProceed = () => {
    this.setState({ showConfirmSavePopup: false }, () =>
      this.onSubmit(this.sendEPLEmail),
    );
  };

  onPrintEPLTemplate = () => {
    const includeWoList = (this.state.workOrderTitleList || [])
      .filter((item) => item.checked)
      .map((item) => item.refNo);

    this.props.dispatch({
      type: RFSActionType.PRINT_EOF_TEMPLATE_ASYNC,
      params: {
        RefNo: Number(this.state.refNo),
        TimeZoneOffset: -new Date().getTimezoneOffset(),
        IncludeWoList: includeWoList,
      },
      callback: (status, content) => {
        if (status) {
          printEOF(content);
        } else {
          this.setState({ showErrorModal: true });
        }
      },
    });
  };

  onPrintEPLTemplateByButton = () => {
    const includeWoList = (this.state.workOrderTitleList || [])
      .filter((item) => item.checked)
      .map((item) => item.refNo);

    this.props.dispatch({
      type: RFSActionType.PRINT_EPL_TEMPLATE_ASYNC,
      params: {
        RefNo: Number(this.state.refNo),
        TimeZoneOffset: -new Date().getTimezoneOffset(),
        IncludeWoList: includeWoList,
      },
      callback: (status) => {
        if (!status) {
          this.setState({ showErrorModal: true });
        }
      },
    });
  };

  onPrintEPLTemplateAndSaveEOC = () => {
    this.onSubmit(() => {
      this.onPrintEPLTemplate();
    });
  };

  onPrintEPLTemplateByButtonAndSaveEOC = () => {
    this.onSubmit(() => {
      this.onPrintEPLTemplateByButton();
    });
  };

  onCancel = () => {
    this.props.history.push(`/punch-lists/${this.state.refNo}`);
  };

  onSubmit = (callback) => {
    const { inspectors, finalAccepted } = this.state;

    this.uploadMultiSignatureToS3(() => {
      this.props.dispatch({
        type: RFSActionType.SUBMIT_EPL_LIST_ASYNC,
        params: {
          data: {
            id: this.state.id,
            refNo: this.state.refNo,
            project: this.state.project,
            buildingPhase: this.state.buildingPhase,
            address: this.state.address,
            dateCreated: this.state.dateCreated,
            buildingDepartmentFinalDate: this.state.buildingDepartmentFinalDate,
            gcContractor: {
              name: inspectors[0].name,
              signatureUrl: inspectors[0].signatureUrl,
              signatureDate: inspectors[0].signatureDate,
            },
            propertyManager: {
              name: inspectors[1].name,
              signatureUrl: inspectors[1].signatureUrl,
              signatureDate: inspectors[1].signatureDate,
            },
            ownerRep: {
              name: inspectors[2].name,
              signatureUrl: inspectors[2].signatureUrl,
              signatureDate: inspectors[2].signatureDate,
            },
            finalAccepted: {
              name: finalAccepted.name,
              signatureUrl: finalAccepted.signatureUrl,
              signatureDate: finalAccepted.signatureDate,
            },

            items: Object.entries(this.state.checkboxes)
              .filter((el) => el[1].some((i) => i))
              .map((el) => ({
                id: el[0],
                isCheckedGcContractor: el[1][0],
                isCheckedPropertyManager: el[1][1],
                isCheckedOwnerRep: el[1][2],
              })),
          },
        },
        callback: (isSuccess) => {
          if (isSuccess) {
            this.setState({ unSavedChange: false });
            callback();
          } else {
            this.setState({ showErrorModal: true });
          }
        },
      });
    });
  };

  uploadMultiSignatureToS3 = (callback) => {
    const { refNo } = this.state;
    let signatures = this.state.inspectors.map((i) => ({
      signatureUrl: i.signatureUrl,
      signatureData: i.signatureData,
    }));

    signatures.push({
      signatureUrl: this.state.finalAccepted.signatureUrl,
      signatureData: this.state.finalAccepted.signatureData,
    });

    if (signatures.findIndex((e) => !e.signatureUrl && e.signatureData) > -1) {
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `/request-for-services/${refNo}/signatures`,
        },
        callback: (awsCredential, isSuccess) => {
          if (isSuccess) {
            this.awsCredential = awsCredential;
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_MULTI_SIGNATURE_TO_S3_ASYNC,
              params: {
                refNo,
                data: signatures,
                config: this.awsCredential,
              },
              callback: (status, data) => {
                if (status === true) {
                  this.getMultiSignatureUrl(data, callback);
                } else {
                  this.setState({ showErrorModal: true });
                }
              },
            });
          } else {
            this.setState({ showErrorModal: true });
          }
        },
      });
    } else {
      this.getMultiSignatureUrl(
        signatures.map((s) => s.signatureUrl),
        callback,
      );
    }
  };

  uploadSignatureToS3 = (inspectorIndex) => {
    const { refNo } = this.state;

    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `request-for-services/${refNo}/signatures`,
      },
      callback: (awsCredential) => {
        this.awsCredential = awsCredential;
        this.props.dispatch({
          type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
          paramsUpload: {
            refNo,
            data: this.state.inspectors[inspectorIndex].signatureData,
            config: {
              ...this.awsCredential,
              path: this.awsCredential.path,
            },
          },
          callback: (status, callbackData) => {
            if (status === true) {
              this.getSignatureUrl(callbackData, inspectorIndex);
            }
          },
        });
      },
    });
  };

  uploadFinalAcceptedSignatureToS3 = (signatureData) => {
    const { refNo } = this.state;

    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `/request-for-services/${refNo}/signatures`,
      },
      callback: (awsCredential) => {
        this.awsCredential = awsCredential;
        this.props.dispatch({
          type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
          paramsUpload: {
            refNo,
            data: signatureData,
            config: {
              ...this.awsCredential,
              path: this.awsCredential.path,
            },
          },
          callback: (status, callbackData) => {
            if (status === true) {
              this.getFinalAcceptedSignatureUrl(callbackData);
            }
          },
        });
      },
    });
  };

  saveSignature = (inspectorIndex) => {
    let { inspectors } = this.state;

    inspectors[inspectorIndex].signatureData =
      inspectors[inspectorIndex].reference.toDataURL("image/png");
    this.setState({ inspectors: inspectors, unSavedChange: true });
  };

  saveFinalAcceptedSignature = () => {
    let { finalAccepted } = this.state;

    finalAccepted.signatureData =
      finalAccepted.reference.toDataURL("image/png");
    this.setState({ finalAccepted: finalAccepted, unSavedChange: true });
  };

  getSignatureUrl = (callbackData, inspectorIndex) => {
    let { inspectors } = this.state;

    inspectors[inspectorIndex].signatureUrl = callbackData.data.Location;
    this.setState({ inspectors: inspectors });
  };

  getMultiSignatureUrl = (data, callback) => {
    let { inspectors, finalAccepted } = this.state;

    data.forEach((value, index) => {
      if (index < 3) {
        inspectors[index].signatureUrl = value;
      } else {
        finalAccepted.signatureUrl = value;
      }
    });

    this.setState(
      { inspectors: inspectors, finalAccepted: finalAccepted },
      callback,
    );
  };

  getFinalAcceptedSignatureUrl = (callbackData) => {
    let { finalAccepted } = this.state;

    finalAccepted.signatureUrl = callbackData.data.Location;
    this.setState({ finalAccepted: finalAccepted });
  };

  onChangeSignatureDate = (inspectorIndex, value) => {
    let validDate = value;
    let { inspectors } = this.state;

    inspectors[inspectorIndex].error = null;

    if (value) {
      if (Moment(value, "MM/DD/YYYY", true).isValid()) {
        validDate = value;
      } else if (Moment(value, "DD/MM/YYYY", true).isValid()) {
        validDate = Moment(Moment(value, "DD/MM/YYYY")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/DD/MM", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/DD/MM")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/MM/DD", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/MM/DD")).format("MM/DD/YYYY");
      } else {
        inspectors[inspectorIndex].error = "Invalid date";
      }
    }

    inspectors[inspectorIndex].signatureDate = validDate;
    this.setState({ inspectors: inspectors, unSavedChange: true });
  };

  onChangeDate = (type, value) => {
    let validDate = value;
    let error = { ...this.state.error, [type]: null };

    if (value) {
      if (Moment(value, "MM/DD/YYYY", true).isValid()) {
        validDate = value;
      } else if (Moment(value, "DD/MM/YYYY", true).isValid()) {
        validDate = Moment(Moment(value, "DD/MM/YYYY")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/DD/MM", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/DD/MM")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/MM/DD", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/MM/DD")).format("MM/DD/YYYY");
      } else {
        error = { ...this.state.error, [type]: "Invalid date" };
      }
    }

    this.setState({ [type]: validDate, error: error, unSavedChange: true });
  };

  onChangeText = (fieldName, value) => {
    this.setState({ [fieldName]: value, unSavedChange: true });
  };

  onFinalAcceptedChangeDate = (value) => {
    let validDate = value;
    let error = null;

    if (value) {
      if (Moment(value, "MM/DD/YYYY", true).isValid()) {
        validDate = value;
      } else if (Moment(value, "DD/MM/YYYY", true).isValid()) {
        validDate = Moment(Moment(value, "DD/MM/YYYY")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/DD/MM", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/DD/MM")).format("MM/DD/YYYY");
      } else if (Moment(value, "YYYY/MM/DD", true).isValid()) {
        validDate = Moment(Moment(value, "YYYY/MM/DD")).format("MM/DD/YYYY");
      } else {
        error = "Invalid date";
      }
    }

    this.setState({
      finalAccepted: {
        ...this.state.finalAccepted,
        signatureDate: validDate,
        error: error,
      },
      unSavedChange: true,
    });
  };

  handleChange(tags) {
    let tagsValid = [];

    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    tags.map((tag) => {
      if (emailPattern.test(tag)) {
        tagsValid.push(tag);
      }
    });

    this.setState({
      recipientEmail: tagsValid,
    });
  }

  disabledSendEmail = () => {
    if (this.state.recipientEmail.length === 0) {
      return true;
    }

    return false;
  };

  resetSignatureUrl = (inspectorIndex) => {
    let { inspectors } = this.state;

    inspectors[inspectorIndex].signatureUrl = null;

    if (inspectors[inspectorIndex].reference) {
      inspectors[inspectorIndex].reference.clear();
      inspectors[inspectorIndex].signatureData = null;
    }

    this.setState({ inspectors: inspectors, unSavedChange: true });
  };

  resetFinalAcceptedSignatureUrl = () => {
    let { finalAccepted } = this.state;

    finalAccepted.signatureUrl = null;

    if (finalAccepted.reference) {
      finalAccepted.reference.clear();
      finalAccepted.signatureData = null;
    }

    this.setState({ finalAccepted: finalAccepted, unSavedChange: true });
  };

  initSignatureCanvas = (inspector, ref) => {
    // if (inspector.initailized === true) {return;}
    // if (inspector.signatureUrl && ref) {
    //   inspector.reference = ref;
    //   this.toDataURL(inspector.signatureUrl, (response) => {
    //     ref.fromDataURL(response);
    //     inspector.initailized = true;
    //   });
    // }
  };

  renderInspectorSignature = () => {
    const { inspectors, customTitles } = this.state;

    if (Array.isArray(inspectors)) {
      return (
        <Row style={{ paddingTop: 30 }}>
          {inspectors.map((inspector, index) => {
            const displayTitle =
              customTitles[index] ||
              InspectorList[index].fullTitle ||
              InspectorList[index].title;
            return (
              <Col key={"inspector_" + index} xs={4}>
                <div
                  className="buyer-signature"
                  style={{ textAlign: "center" }}
                >
                  <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {displayTitle}
                  </span>
                </div>
                {!inspector.signatureData && inspector.signatureUrl ? (
                  <div
                    className="signature-pad-buyer-orientation"
                    style={{
                      top: "-6px",
                      bottom: "15px",
                      right: "10px",
                      textAlign: "center",
                      minHeight: 150,
                      marginTop: 10,
                    }}
                  >
                    <button
                      type="button"
                      className="close"
                      onClick={() => this.resetSignatureUrl(index)}
                    >
                      &times;
                    </button>
                    <img
                      style={{ width: 300, height: 150 }}
                      src={inspector.signatureUrl}
                    />
                  </div>
                ) : (
                  <div
                    className="signature-pad"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="button"
                      className="close"
                      onClick={() => this.resetSignatureUrl(index)}
                    >
                      &times;
                    </button>
                    <SignatureCanvas
                      className="buyerSignature1"
                      penColor="black"
                      ref={(ref) => {
                        inspector.reference = ref;
                      }}
                      onEnd={() => this.saveSignature(index)}
                      canvasProps={{
                        top: "-6px",
                        bottom: "15px",
                        right: "10px",
                        marginLeft: 120,
                        margintop: 20,
                        width: 300,
                        maxwidth: 350,
                        height: 150,
                      }}
                    />
                  </div>
                )}
                <div className="buyer-signature">
                  <Row className="eoc-signature-date">
                    <div
                      className="col-md-3 col-lg-3 col-xs-3"
                      style={{ textAlign: "right", marginTop: 8, left: 25 }}
                    >
                      <span style={{ fontSize: 16, fontWeight: 700 }}>
                        Date
                      </span>
                    </div>
                    <div
                      className="col-md-7 col-lg-7 col-xs-7"
                      style={{ marginLeft: 25, marginTop: 10 }}
                    >
                      <Datetime
                        className="date-time-eoc-list"
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        inputProps={{ placeholder: "MM/DD/YYYY" }}
                        value={inspector.signatureDate}
                        onChange={(e) => this.onChangeSignatureDate(index, e)}
                        closeOnSelect={true}
                      />
                      {inspector.error && (
                        <span
                          className="text-danger"
                          style={{ fontSize: 12, marginTop: 5 }}
                        >
                          {inspector.error}
                        </span>
                      )}
                    </div>
                  </Row>
                </div>
              </Col>
            );
          })}
        </Row>
      );
    }
    return null;
  };

  renderFinalAcceptedSignature = () => {
    let { finalAccepted } = this.state;

    return (
      <Row style={{ paddingTop: 30 }}>
        <Col xs={4}>
          <div className="buyer-signature" style={{ textAlign: "center" }}>
            <span style={{ fontSize: 16, fontWeight: 700 }}>
              Final Accepted
            </span>
          </div>
          {!finalAccepted.signatureData && finalAccepted.signatureUrl ? (
            <div
              className="signature-pad-buyer-orientation"
              style={{
                top: "-6px",
                bottom: "15px",
                right: "10px",
                textAlign: "center",
                minHeight: 150,
                marginTop: 10,
              }}
            >
              <button
                type="button"
                className="close"
                onClick={() =>
                  this.resetFinalAcceptedSignatureUrl(finalAccepted)
                }
              >
                &times;
              </button>
              <img
                style={{ width: 300, height: 150 }}
                src={finalAccepted.signatureUrl}
              />
            </div>
          ) : (
            <div className="signature-pad" style={{ textAlign: "center" }}>
              <button
                type="button"
                className="close"
                onClick={() =>
                  this.resetFinalAcceptedSignatureUrl(finalAccepted)
                }
              >
                &times;
              </button>
              <SignatureCanvas
                className="buyerSignature1"
                penColor="black"
                ref={(ref) => {
                  finalAccepted.reference = ref;
                }}
                onEnd={() => this.saveFinalAcceptedSignature()}
                canvasProps={{
                  top: "-6px",
                  bottom: "15px",
                  right: "10px",
                  marginLeft: 120,
                  margintop: 20,
                  width: 300,
                  maxwidth: 350,
                  height: 150,
                }}
              />
            </div>
          )}
          <div className="buyer-signature">
            <Row className="eoc-signature-date">
              <div
                className="col-md-3 col-lg-3 col-xs-3"
                style={{ textAlign: "right", marginTop: 8, left: 25 }}
              >
                <span style={{ fontSize: 16, fontWeight: 700 }}>Date</span>
              </div>
              <div
                className="col-md-7 col-lg-7 col-xs-7"
                style={{ marginLeft: 25, marginTop: 10 }}
              >
                <Datetime
                  className="date-time-eoc-list"
                  timeFormat={false}
                  dateFormat="MM/DD/YYYY"
                  inputProps={{ placeholder: "MM/DD/YYYY" }}
                  value={finalAccepted.signatureDate}
                  defaultValue={
                    finalAccepted.signatureDate
                      ? Moment(finalAccepted.signatureDate).format("MM/DD/YYYY")
                      : ""
                  }
                  onChange={(e) => this.onFinalAcceptedChangeDate(e)}
                  closeOnSelect={true}
                />
                {finalAccepted.error && (
                  <span
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: 5 }}
                  >
                    {finalAccepted.error}
                  </span>
                )}
              </div>
            </Row>
          </div>
        </Col>
      </Row>
    );
  };

  openAttachmentModal = (urls) => {
    this.setState({
      showAttachmentModal: true,
      currentAttachmentUrls: urls,
    });
  };

  closeAttachmentModal = () => {
    this.setState({
      showAttachmentModal: false,
      currentAttachmentUrls: [],
    });
  };

  renderAttachmentModal = () => {
    const { showAttachmentModal, currentAttachmentUrls } = this.state;
    return (
      <Modal
        show={showAttachmentModal}
        onHide={this.closeAttachmentModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {currentAttachmentUrls && currentAttachmentUrls.length > 0 ? (
            <Carousel
              interval={null}
              controls={currentAttachmentUrls.length > 1}
              indicators={currentAttachmentUrls.length > 1}
            >
              {currentAttachmentUrls.map((url, index) => (
                <Carousel.Item key={index}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "500px",
                    }}
                  >
                    {url.toLowerCase().endsWith(".pdf") ? (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        View PDF
                      </a>
                    ) : (
                      <img
                        className="d-block w-100"
                        src={url}
                        alt={`Attachment ${index + 1}`}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "500px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <p>No attachments found.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-default"
            onClick={this.closeAttachmentModal}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  toggleAllWorkOrders = () => {
    const { workOrderTitleList } = this.state;
    const allChecked = workOrderTitleList.every((item) => item.checked);
    const newList = workOrderTitleList.map((item) => ({
      ...item,
      checked: !allChecked,
    }));
    this.setState({ workOrderTitleList: newList });
  };

  toggleWorkOrder = (index) => {
    const { workOrderTitleList } = this.state;
    const newList = [...workOrderTitleList];
    newList[index] = { ...newList[index], checked: !newList[index].checked };
    this.setState({ workOrderTitleList: newList });
  };

  renderWOSection = () => {
    const { workOrderTitleList } = this.state;
    console.log("workOrderTitleList", workOrderTitleList);

    if (workOrderTitleList && workOrderTitleList.length > 0) {
      const allChecked = workOrderTitleList.every((item) => item.checked);
      return (
        <div className="custom-template-section-item">
          <div className="section-items checklist-header wo-section-header">
            <div className="col-xs-9 section-name vertical-center">
              The following items require attention
            </div>
            <div
              className="col-xs-2 section-name vertical-center"
              style={{ justifyContent: "flex-end", paddingRight: 0, position: "relative", left: "30px" }}
            >
              Include in Report
            </div>
            <div className="col-xs-1 vertical-center cell wo-actions">
              <i
                className="glyphicon glyphicon-paperclip"
                style={{
                  fontSize: "16px",
                  marginRight: 10,
                  visibility: "hidden",
                }}
              ></i>
              <CheckBoxSingle
                checked={allChecked}
                onChecked={this.toggleAllWorkOrders}
              />
            </div>
          </div>
          {this.renderWOItems(workOrderTitleList)}
        </div>
      );
    }

    return null;
  };

  renderWOItems = (section) => {
    return (
      <React.Fragment>
        {section.map((item, index) => (
          <div className="checklist-item clearfix wo-item-row" key={index}>
            <div className="col-xs-1 vertical-center cell" style={{ width: 50, paddingRight: 0 }}>{index + 1}.</div>
            <div className="col-xs-10 cell wo-content" style={{ width: "calc(91.666667% - 50px)", paddingLeft: 10 }}>
              <div className="wo-data-row" style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <span className="wo-label">Trade - </span> {item.trade}
                </div>
                <div style={{ flex: 1 }}>
                  <span className="wo-label">Location - </span>{" "}
                  {item.location}
                </div>
                <div style={{ flex: 1 }}>
                  <span className="wo-label">Status - </span>{" "}
                  {item.woStatus}
                </div>
              </div>
              <div className="wo-data-row">
                <span className="wo-label">Title - </span> {item.title}
              </div>
              <div className="wo-data-row">
                <span className="wo-label">Description - </span>{" "}
                {item.discription}
              </div>
            </div>
            <div className="col-xs-1 vertical-center cell wo-actions">
              {item.urls && item.urls.length > 0 ? (
                <i
                  className="glyphicon glyphicon-paperclip"
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    marginRight: 10,
                  }}
                  onClick={() => this.openAttachmentModal(item.urls)}
                ></i>
              ) : (
                <i
                  className="glyphicon glyphicon-paperclip"
                  style={{
                    fontSize: "16px",
                    marginRight: 10,
                    visibility: "hidden",
                  }}
                ></i>
              )}
              <CheckBoxSingle
                checked={item.checked}
                onChecked={() => this.toggleWorkOrder(index)}
              />
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  };

  renderCheckListItems = (section) => {
    if (section.items.length === 0) {
      return null;
    }

    return (
      <React.Fragment>
        {section.items.map((item, i) => {
          return (
            <div key={item.id} className="checklist-item clearfix">
              <div className="col-xs-1 vertical-center cell" style={{ width: 50, paddingRight: 0 }}>{i + 1}.</div>
              <div className="col-xs-8 vertical-center cell" style={{ width: "calc(75% - 50px)", paddingLeft: 10 }}>{item.name}</div>
              {this.state.checkboxes[item.id].map((el, checkedIndex) => (
                <div
                  key={`${item.id}_col_${checkedIndex}`}
                  className="col-xs-1 vertical-center"
                  style={{
                    backgroundColor: InspectorList[checkedIndex].color,
                    justifyContent: "center",
                  }}
                >
                  <CheckBoxSingle
                    name="checkbox1"
                    style={{ margin: 0 }}
                    checked={this.state.checkboxes[item.id][checkedIndex]}
                    value={item.id}
                    onChecked={(e, v, d) => this.onChecked(checkedIndex, v, d)}
                  />
                </div>
              ))}
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  renderSections = () => {
    const { sections, customTitles } = this.state;

    if (Array.isArray(sections)) {
      return (
        <React.Fragment>
          {sections
            .sort((a, b) => a.order - b.order)
            .map((section, index) => {
              return (
                <div
                  key={`section_${index}`}
                  className="custom-template-section-item"
                >
                  <div className="section-items checklist-header">
                    <div className="col-xs-9 section-name vertical-center">
                      {section.name}
                    </div>
                    {InspectorList.map((el, i) => {
                      const displayTitle = customTitles[i] || el.title;
                      return (
                        <div
                          key={`section${index}_col_${i}`}
                          className="col-xs-1 vertical-center"
                          style={{
                            color: "white",
                            fontSize: 14,
                            fontWeight: 700,
                            textAlign: "center",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            paddingTop: 10,
                            paddingBottom: 10,
                          }}
                        >
                          <div>{displayTitle}</div>
                          <CheckBoxSingle
                            name={`selectAll_${index}_${i}`}
                            style={{ margin: 0, marginTop: "auto" }}
                            checked={this.isAllCheckedInSection(section, i)}
                            onChecked={(e, v, d) =>
                              this.onSelectAllInSection(section, i, d.checked)
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                  {this.renderCheckListItems(section, index)}
                </div>
              );
            })}
        </React.Fragment>
      );
    }
    return null;
  };

  changeInspectorName = (inspectorIndex, value) => {
    let { inspectors } = this.state;

    inspectors[inspectorIndex].name = value;
    this.setState({ inspectors: inspectors, unSavedChange: true });
  };

  isInvalidData = () => {
    const { error, inspectors, finalAccepted } = this.state;

    if (Object.entries(error).some((entry) => entry[1])) {
      return true;
    }

    if (inspectors.some((item) => item.error)) {
      return true;
    }

    if (finalAccepted.error) {
      return true;
    }

    return false;
  };

  renderHeader = () => {
    const { error, homeOwnerInfo } = this.state;

    return (
      <React.Fragment>
        <div
          className="eoc-table-list"
          style={{ marginTop: 20, marginBottom: 20 }}
        >
          <Table
            className="form-horizontal"
            style={{ border: "1px solid lightgray" }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    borderRight: "1px solid lightgray",
                    padding: 15,
                    width: "50%",
                    verticalAlign: "top",
                  }}
                >
                  <div className="form-group">
                    <label className="col-md-3">
                      <b style={{ textTransform: "capitalize" }}>
                        {this.state.customSettings.project || "Project"}
                      </b>
                    </label>
                    <Col md={5}>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.project}
                        onChange={(e) =>
                          this.onChangeText("project", e.target.value)
                        }
                      />
                    </Col>
                  </div>
                  <div className="form-group">
                    <label className="col-md-3">
                      <b>{this.state.customSettings.phase || "Building / Phase #"}</b>
                    </label>
                    <Col md={5}>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.buildingPhase}
                        onChange={(e) =>
                          this.onChangeText("buildingPhase", e.target.value)
                        }
                      />
                    </Col>
                  </div>
                  <div className="form-group">
                    <label className="col-md-3">
                      <b>Address</b>
                    </label>
                    <Col md={5}>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.address}
                        maxLength={256}
                        onChange={(e) =>
                          this.onChangeText("address", e.target.value)
                        }
                      />
                    </Col>
                  </div>
                </td>
                <td style={{ padding: 15, verticalAlign: "top" }}>
                  <div className="form-group">
                    <label className="col-md-4">
                      <b>Date Created</b>
                    </label>
                    <Col md={5}>
                      <Datetime
                        inputProps={{ placeholder: "MM/DD/YYYY" }}
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        value={this.state.dateCreated}
                        onChange={(e) => this.onChangeDate("dateCreated", e)}
                        closeOnSelect={true}
                      />
                      {error.dateCreated && (
                        <span
                          className="text-danger"
                          style={{ fontSize: 12, marginTop: 5 }}
                        >
                          {error.dateCreated}
                        </span>
                      )}
                    </Col>
                  </div>
                  <div className="form-group">
                    <label className="col-md-4">
                      <b>Building Department Final Date</b>
                    </label>
                    <Col md={5}>
                      <Datetime
                        inputProps={{ placeholder: "MM/DD/YYYY" }}
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        value={this.state.buildingDepartmentFinalDate}
                        onChange={(e) =>
                          this.onChangeDate("buildingDepartmentFinalDate", e)
                        }
                        closeOnSelect={true}
                      />
                      {error.buildingDepartmentFinalDate && (
                        <span
                          className="text-danger"
                          style={{ fontSize: 12, marginTop: 5 }}
                        >
                          {error.buildingDepartmentFinalDate}
                        </span>
                      )}
                    </Col>
                  </div>
                  {homeOwnerInfo && (
                    <div className="form-group" style={{ marginTop: 15 }}>
                      <label className="col-md-4">
                        <b>Home Owner Info</b>
                      </label>
                      <Col md={8}>
                        {homeOwnerInfo.name && (
                          <div style={{ marginBottom: 5 }}>
                            <b>Name:</b> {homeOwnerInfo.name}
                          </div>
                        )}
                        {homeOwnerInfo.email && (
                          <div style={{ marginBottom: 5 }}>
                            <b>Email:</b> {homeOwnerInfo.email}
                          </div>
                        )}
                        {homeOwnerInfo.phoneNo && (
                          <div>
                            <b>Phone:</b> {homeOwnerInfo.phoneNo}
                          </div>
                        )}
                      </Col>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td
                  style={{ borderRight: "1px solid lightgray", padding: 15 }}
                  colSpan={2}
                >
                  <div className="form-group">
                    <label className="col-md-2">
                      <b>
                        {/* Inspectors:{" "} */}
                        {this.state.customTitles[0] || "GC/Contractor"}
                      </b>
                    </label>
                    <Col md={8}>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          this.state.inspectors[InspectorEnum.GCContractor].name
                        }
                        maxLength={256}
                        onChange={(e) =>
                          this.changeInspectorName(
                            InspectorEnum.GCContractor,
                            e.target.value,
                          )
                        }
                      />
                    </Col>
                  </div>
                  <div className="form-group">
                    <label className="col-md-2">
                      <b>
                        {/* Inspectors:{" "} */}
                        {this.state.customTitles[1] ||
                          "Property manager or equal"}
                      </b>
                    </label>
                    <Col md={8}>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          this.state.inspectors[InspectorEnum.Property].name
                        }
                        maxLength={256}
                        onChange={(e) =>
                          this.changeInspectorName(
                            InspectorEnum.Property,
                            e.target.value,
                          )
                        }
                      />
                    </Col>
                  </div>
                  <div className="form-group">
                    <label className="col-md-2">
                      <b>
                        {/* Inspectors:{" "} */}
                        {this.state.customTitles[2] || "Owner rep or equal"}
                      </b>
                    </label>
                    <Col md={8}>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.inspectors[InspectorEnum.Owner].name}
                        maxLength={256}
                        onChange={(e) =>
                          this.changeInspectorName(
                            InspectorEnum.Owner,
                            e.target.value,
                          )
                        }
                      />
                    </Col>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </React.Fragment>
    );
  };

  onCloseModal = () => {
    this.setState({ showErrorModal: false });
  };

  renderModal = () => {
    return (
      <Modal
        dialogClassName="confirm-cancel-save-eoc-template-dialog"
        show={this.state.showErrorModal}
        size="sm"
      >
        <Modal.Header>
          <Modal.Title style={{ fontWeight: "bold" }}>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{this.state.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ float: "left" }}>
            <button
              className="btn btn-primary btn-siteone"
              onClick={this.onCloseModal}
            >
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const disabledSendEmail = this.disabledSendEmail();
    const disabledSave = this.isInvalidData();
    const { builderInfo, disclaimer } = this.state;
    console.log("render", this.state);
    return (
      <React.Fragment>
        <div className="rfs-detail">
          <div className="page-title clearfix">
            <h2 className="pull-left">{this.state.templateName}</h2>
            <div style={{ marginTop: 15 }} className="text-right print-icon">
              &nbsp;
              {
                <i
                  onClick={
                    this.state.unSavedChange
                      ? this.onPrintEPLTemplateAndSaveEOC
                      : this.onPrintEPLTemplate
                  }
                  className="glyphicon glyphicon-print"
                  style={{ cursor: "pointer" }}
                />
              }
            </div>
            {
              <ul className="breadcrumb">
                <li>
                  <Link to={"/punch-lists"}>
                    {<Translate translateKey="punchlist" capitalize />}
                  </Link>
                </li>
                <li className="breadcrumb-siteone-li">
                  <Link to={`/punch-lists/${this.state.refNo}`}>
                    BT #{this.state.refNo}
                  </Link>
                </li>
                <li className="breadcrumb-siteone-li">EPL</li>
              </ul>
            }
          </div>
          <div className="wrapper box-form-siteone" style={{ padding: "20px" }}>
            <h3 style={{ marginBottom: 20, marginTop: 0 }}>
              {this.state.templateName}
            </h3>
            {
              <div style={{ margin: "10px 0" }}>
                <div className="row form-horizontal">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="col-md-3">{builderInfo.name}</label>
                      <div className="col-md-9">{builderInfo.address}</div>
                    </div>
                    <div className="form-group">
                      <label className="col-md-3">{builderInfo.phone}</label>
                      <div className="col-md-9">{builderInfo.email}</div>
                    </div>
                  </div>
                  <div
                    className="col-md-6 builder-logo"
                    style={{ textAlign: "center", maxHeight: 75 }}
                  >
                    <img
                      className="logo"
                      style={{ maxHeight: 75 }}
                      src={builderInfo.logoUrl}
                    />
                  </div>
                </div>
              </div>
            }

            {this.renderHeader()}

            {this.renderSections()}

            {this.renderWOSection()}

            {
              <div
                style={{ marginLeft: 0, whiteSpace: "pre-line" }}
                className="row disclaimer-text"
              >
                {disclaimer}
              </div>
            }

            {this.renderInspectorSignature()}
            {this.renderFinalAcceptedSignature()}

            <div
              className="modal-footer"
              style={{
                float: "left",
                marginTop: 30,
                borderTop: "none",
                width: 800,
              }}
            >
              {
                <Row>
                  <Col
                    style={{
                      borderRight: "1px solid lightgray",
                      textAlign: "left",
                      width: 225,
                    }}
                    xs={4}
                  >
                    <button
                      style={{ marginRight: 10 }}
                      onClick={this.onCancel}
                      className="btn btn-primary btn-siteone-default"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => this.onSubmit(this.getEPL)}
                      disabled={disabledSave}
                      className="btn btn-primary btn-siteone"
                    >
                      Save
                    </button>
                  </Col>
                  <Col style={{ marginLeft: 12 }} xs={6}>
                    <div className="button-function-eoc">
                      <button
                        onClick={this.onClickOnEmailButton}
                        disabled={disabledSave}
                        className="btn btn-primary btn-siteone-orange"
                      >
                        Email...
                      </button>
                      <button
                        onClick={
                          this.state.unSavedChange
                            ? this.onPrintEPLTemplateByButtonAndSaveEOC
                            : this.onPrintEPLTemplateByButton
                        }
                        disabled={disabledSave}
                        className="btn btn-primary btn-siteone-orange"
                        style={{ marginLeft: 10 }}
                      >
                        Print
                      </button>
                      {this.state.showEmailInputBox && (
                        <Popup
                          ref={(ref) => {
                            this.sendEmailPopup = ref;
                          }}
                          className="reopen-popup"
                          isHasFaded={true}
                          styles={popupStyle}
                        >
                          <div className="recipients-email-eoc container-fluid">
                            <label>
                              Recipients <span className="text-danger">*</span>
                            </label>
                            <button
                              type="button"
                              className="close"
                              onClick={this.onCloseEmailBox}
                            >
                              &times;
                            </button>
                            <TagsInput
                              value={this.state.recipientEmail}
                              onChange={(tags) => {
                                this.handleChange(tags, 0);
                              }}
                              inputProps={this.state.inputProps}
                              addKeys={TAGS_LIST}
                              addOnBlur
                              autoFocus
                              onlyUnique={true}
                              suggestions={this.state.suggestions}
                              autocomplete={true}
                            />
                            <button
                              disabled={disabledSendEmail}
                              onClick={this.onClickSendInEmailBox}
                              style={{ float: "left", marginTop: 7 }}
                              className="btn btn-primary btn-siteone"
                            >
                              Send
                            </button>
                          </div>
                        </Popup>
                      )}
                      {this.state.showConfirmSavePopup && (
                        <Popup
                          className="reopen-popup"
                          styles={{
                            width: 330,
                            height: 150,
                            top: -172,
                            left: 160,
                          }}
                        >
                          <div className="recipients-email-eoc container-fluid">
                            <label>Confirmation </label>
                            <div style={{ marginTop: 5 }}>
                              You have unsaved changes. Do you want to save
                              before proceeding?
                            </div>
                          </div>
                          <div className="button-save-confirm-popup">
                            <button
                              type="button"
                              className="btn btn-primary btn-siteone-default"
                              onClick={() =>
                                this.setState({ showConfirmSavePopup: false })
                              }
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-primary btn-siteone"
                              style={{ marginLeft: 10 }}
                              onClick={this.onClickSaveAndProceed}
                            >
                              Save and Proceed
                            </button>
                          </div>
                        </Popup>
                      )}
                    </div>
                  </Col>
                </Row>
              }
            </div>
          </div>

          <iframe
            id="ifmcontentstoprint"
            style={{ height: 0, border: "none" }}
          />
        </div>

        {this.state.showErrorModal && this.renderModal()}
        {this.renderAttachmentModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    EPLProfile: state.RFSStore.EPLProfile,
  };
};

export default connect(mapStateToProps)(EPLForm);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/epl-form.js